export const SEARCH_STORE_ID = "searchBar";